import { render, staticRenderFns } from "./LKI01.vue?vue&type=template&id=1706a2c1"
import script from "./LKI01.vue?vue&type=script&lang=js"
export * from "./LKI01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports